import React from 'react';
import PropTypes from 'prop-types';
import { Svg, Path } from 'react-native-svg';

const B2C = ({ color, className }) => (
    <Svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.99988 12.9998C11.8299 12.9998 13.8599 12.3798 14.6299 12.0698L15.3699 13.9298C14.4699 14.2898 12.1699 14.9998 9.99988 14.9998C7.82988 14.9998 5.52988 14.2898 4.62988 13.9298L5.36988 12.0698C6.13988 12.3798 8.16988 12.9998 9.99988 12.9998Z"
            fill="white"
        />
        <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.99988 12.9998C11.8299 12.9998 13.8599 12.3798 14.6299 12.0698L15.3699 13.9298C14.4699 14.2898 12.1699 14.9998 9.99988 14.9998C7.82988 14.9998 5.52988 14.2898 4.62988 13.9298L5.36988 12.0698C6.13988 12.3798 8.16988 12.9998 9.99988 12.9998Z"
            fill={color}
            fillOpacity="0.5"
        />
        <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18 10C18 7.88 17.16 5.84 15.66 4.34C14.16 2.84 12.12 2 10 2C7.88 2 5.84 2.84 4.34 4.34C2.84 5.84 2 7.88 2 10C2 12.12 2.84 14.16 4.34 15.66C5.84 17.16 7.88 18 10 18C12.12 18 14.16 17.16 15.66 15.66C17.16 14.16 18 12.12 18 10ZM20 10C20 12.65 18.95 15.2 17.07 17.07C15.2 18.95 12.65 20 10 20C8.69 20 7.39 19.74 6.17 19.24C4.96 18.74 3.85 18 2.93 17.07C1.05 15.2 0 12.65 0 10C0 7.35 1.05 4.8 2.93 2.93C4.8 1.05 7.35 0 10 0C11.31 0 12.61 0.26 13.83 0.76C15.04 1.26 16.15 2 17.07 2.93C18 3.86 18.74 4.96 19.24 6.17C19.74 7.39 20 8.69 20 10ZM8 8.5C8 9.3 7.3 10 6.5 10C5.7 10 5 9.3 5 8.5C5 7.7 5.7 7 6.5 7C7.3 7 8 7.7 8 8.5Z"
            fill="white"
        />
        <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18 10C18 7.88 17.16 5.84 15.66 4.34C14.16 2.84 12.12 2 10 2C7.88 2 5.84 2.84 4.34 4.34C2.84 5.84 2 7.88 2 10C2 12.12 2.84 14.16 4.34 15.66C5.84 17.16 7.88 18 10 18C12.12 18 14.16 17.16 15.66 15.66C17.16 14.16 18 12.12 18 10ZM20 10C20 12.65 18.95 15.2 17.07 17.07C15.2 18.95 12.65 20 10 20C8.69 20 7.39 19.74 6.17 19.24C4.96 18.74 3.85 18 2.93 17.07C1.05 15.2 0 12.65 0 10C0 7.35 1.05 4.8 2.93 2.93C4.8 1.05 7.35 0 10 0C11.31 0 12.61 0.26 13.83 0.76C15.04 1.26 16.15 2 17.07 2.93C18 3.86 18.74 4.96 19.24 6.17C19.74 7.39 20 8.69 20 10ZM8 8.5C8 9.3 7.3 10 6.5 10C5.7 10 5 9.3 5 8.5C5 7.7 5.7 7 6.5 7C7.3 7 8 7.7 8 8.5Z"
            fill={color}
            fillOpacity="0.5"
        />
        <Path
            d="M11.2598 8.96994C11.5098 8.49994 11.9898 7.93994 12.8798 7.93994C13.7698 7.93994 14.2498 8.49994 14.4998 8.96994"
            stroke="white"
            strokeWidth="1.7"
            strokeMiterlimit="10"
            strokeLinejoin="bevel"
        />
        <Path
            d="M11.2598 8.96994C11.5098 8.49994 11.9898 7.93994 12.8798 7.93994C13.7698 7.93994 14.2498 8.49994 14.4998 8.96994"
            stroke={color}
            strokeOpacity="0.5"
            strokeWidth="1.7"
            strokeMiterlimit="10"
            strokeLinejoin="bevel"
        />
    </Svg>
);

B2C.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
};

B2C.defaultProps = {
    className: '',
    color: '#022AFF',
};

export default B2C;
